// Search modal close button
(function () {
  var closeBtns = document.querySelectorAll('.search-modal__close-button');
  if (!closeBtns.length) return;

  customElements.whenDefined('details-modal').then(function () {
    closeBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        btn.closest('details-modal').close();
      });
    });
  });
})();

// Mobile menu — replace # placeholder links with semantic span group headings
(function () {
  var placeholderLinks = document.querySelectorAll('.menu-drawer__menu a[href="#"]');
  if (!placeholderLinks.length) return;

  placeholderLinks.forEach(function (link) {
    var title = link.textContent.trim();

    var span = document.createElement('span');
    span.className = link.className
      .replace(/\blink--text\b/, '')
      .replace(/\blink\b/, '')
      .replace(/\bfocus-inset\b/, '')
      .trim();
    span.textContent = title;
    span.setAttribute('aria-hidden', 'true');
    link.parentNode.replaceChild(span, link);

    var parentLi = span.closest('li');
    if (parentLi) {
      parentLi.setAttribute('role', 'presentation');
      var subList = parentLi.querySelector('ul');
      if (subList) subList.setAttribute('aria-label', title);
    }
  });
})();

// Mega menu aria-expanded — mirrors active-hover class onto aria-expanded
(function () {
  var megaMenuParentButtons = document.querySelectorAll('.mega-menu__content .mega-menu__parent-list .hover-me');
  if (!megaMenuParentButtons.length) return;

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.attributeName === 'class') {
        var btn = mutation.target;
        btn.setAttribute('aria-expanded', btn.classList.contains('active-hover') ? 'true' : 'false');
      }
    });
  });

  megaMenuParentButtons.forEach(function (btn) {
    observer.observe(btn, { attributes: true, attributeFilter: ['class'] });
  });
})();
